export default actionName => ({
    [actionName]: actionName,
    [`${actionName}_SUCCESS`]: `${actionName}_SUCCESS`,
    [`${actionName}_FAILURE`]: `${actionName}_FAILURE`
})